import { register } from '../modules/sections.js'
import Section from '../modules/section.js'
import Flickity from 'flickity'
import { on } from '../modules/events.js'

class HeroSection extends Section {
  initState() {
    return {
      sliderIndex: 0
    }
  }

  init() {
    this.computed(() => this.sliderIndexChanged(this.state.sliderIndex))
    this.sliderSetup()
  }

  sliderSetup() {
    if (!this.refs.slider) {
      return 
    }

    // load images and resize
    const images = this.refs.images ?? []
    images.forEach((el) => {
      if (!el.naturalWidth) {
        on(el, 'load', () => {
          setTimeout(() => this.slider.resize(), 100)
        })
      }
    })

    this.slider = new Flickity(
      this.refs.slider,
      {
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        cellAlign: 'left',
        autoPlay: 7000,
      }
    )

    setTimeout(() => this.slider.resize(), 10)

    let timeout
    on(window, 'resize', () => {
      if (!timeout) {
        timeout = setTimeout(() => {
          timeout = null
          this.slider.resize()
        }, 100)
      }
    })

    if (this.slider && this.refs.indexes?.length) {
      this.refs.indexes.forEach((el) => {
        on(el, 'pointerup', () => {
          const index = this.refs.indexes.indexOf(el)
          this.slider.select(index)
        })
      })

      this.slider.on('change', (i) => {
        this.state.sliderIndex = i
      })
    }
  }

  sliderIndexChanged(value) {
    if (this.refs.indexes?.length) {
      this.refs.indexes.forEach((el, i) => {
        el.dataset.current = (i === value) ? 1 : 0
      })
    }
  }
}

register('hero', HeroSection)
